export const PASSWORD_RESET_ATTEMPT = 'PASSWORD_RESET_ATTEMPT';
export type PASSWORD_RESET_ATTEMPT = typeof PASSWORD_RESET_ATTEMPT;

export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export type PASSWORD_RESET_SUCCESS = typeof PASSWORD_RESET_SUCCESS;

export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export type PASSWORD_RESET_FAILURE = typeof PASSWORD_RESET_FAILURE;

export const PASSWORD_RESET_CLEAR_ERRORS = 'PASSWORD_RESET_CLEAR_ERRORS';
export type PASSWORD_RESET_CLEAR_ERRORS = typeof PASSWORD_RESET_CLEAR_ERRORS;


// WEBPACK FOOTER //
// ./src/actions/authentication/password-reset/Types.tsx